import styled from "styled-components"

export const Output = styled.span`
  cursor: pointer;
`

export const TranslatedText = styled.span`
  text-align: inherit;
`
